export default "__VITE_ASSET__DYKRHce6__"